import styled from 'styled-components';
import { COLORS, LAYOUT, ORDER } from '@/constants/styles';

interface StyledToastLayoutProps {
  $status: boolean | null;
}

export const StyledToastLayout = styled.div<StyledToastLayoutProps>`
  background-color: ${({ $status, theme }) =>
    $status ? theme.global.primary_active_color : 'red'};
  display: block;
  padding: ${LAYOUT.GUTTER}px ${LAYOUT.GUTTER * 2}px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${ORDER.TOAST};
  pointer-events: auto;

  @media (max-width: 767px) {
    padding: ${LAYOUT.GUTTER / 2}px ${LAYOUT.GUTTER * 2}px;
  }
`;

export const ToastContent = styled.div`
  color: white;
  font-family: ${({ theme }) => theme.primary_font.medium.font_family};
  font-size: 16px;
  position: relative;
  text-align: center;
  margin-right: 20px;

  p button {
    margin: 0;
    width: calc(100% - ${LAYOUT.GUTTER * 2}px);
  }

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

export const StyledForceDismissButton = styled.button`
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: ${COLORS.WHITE};
  cursor: pointer;
  display: block;
  font-size: 24px;
  height: 100%;
  padding: 0 ${LAYOUT.GUTTER}px;
  position: absolute;
  right: 0;
  top: 0px;
  transition: all 0.2s linear;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

/**
 * The toast's recovery affordances — "Refresh Page", and since TEAM-15138 "Choose your {group}".
 *
 * Renamed from `StyledSecondaryButton` (it is only ever used here, and the name collided with an
 * unrelated component in `components/locations/ctas`) and given the top margin both call sites
 * previously set inline.
 */
export const StyledToastAction = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  font-family: ${({ theme }) => theme.primary_font.bold.font_family};
  margin: 1rem auto 0;
  padding: 0;
  text-align: center;
  text-decoration: underline;
  color: ${COLORS.WHITE};
`;

// TEAM-14387: optional second line under the main toast message. Inherits the colour
// ToastContent sets, so it stays readable on whatever background the brand's theme
// gives StyledToastLayout. Sized relatively so the ratio to the first line survives
// the 767px breakpoint, where ToastContent drops from 16px to 14px.
export const StyledToastSecondaryMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 0.875em;
  line-height: 1.4;
`;
